"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const validators_1 = require("./utils/validators");
const EmailSchemaComponent = (props) => {
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
        validators_1.emailValidator,
    ]);
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        react_1.default.createElement(Form_1.default.Control, Object.assign({ type: "email", className: (0, classnames_1.default)({
                "has-error": fieldState.invalid,
            }), value: value || "" }, registerProps))));
};
EmailSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("EmailDisplayComponent");
exports.default = EmailSchemaComponent;
